import { render, staticRenderFns } from "./SinayIframeModal.vue?vue&type=template&id=2b985078"
import script from "./SinayIframeModal.vue?vue&type=script&lang=js"
export * from "./SinayIframeModal.vue?vue&type=script&lang=js"
import style0 from "./SinayIframeModal.vue?vue&type=style&index=0&id=2b985078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports